import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;

  > div {
    display: flex;
    height: 100vh;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  }
`;
export default Container;

/**
 * Reserves the animation box whether or not the animation has arrived.
 *
 * The animation is fetched as its own chunk now, so without this the 300x300 Lottie appears after
 * first paint and pushes the centred column apart - a viewport-scale layout shift on the very
 * screen that exists to look calm while loading.
 */
export const AnimationSlot = styled.div`
  width: 300px;
  height: 300px;
  flex-shrink: 0;
`;
